<template>
    <div>
        <div class="form-group row mb-3">
            <label class="col-sm-3 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.selectionMethod') }}</label>
            <div class="col-sm-9">
                <InputCheckBox
                    class="mr-4 py-1"
                    :model.sync="formLottery.is_prize_before_the_draw"
                    :id="`selectionMethod`"
                    :value="formLottery.is_prize_before_the_draw"
                    :label="`抽選前に賞品を選択する`"
                    :disabled="isView"
                />
            </div>
        </div>
        <div class="form-group row mb-3">
            <label class="col-sm-3 text-nowrap" style="min-width: 120px">{{ $t('managerForm.settingSerialCode.usedCode') }}</label>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap">
                    <div v-for="item in serialCodeList" :key="item.id + 'sss'">
                        <InputRadio
                            class="mr-3 mb-2"
                            :model.sync="formLottery.used_code"
                            :id="`raido-serialUsed${item.id}`"
                            :name="`radio-serialUsed`"
                            :value="item.id"
                            :label="item.name"
                            :disabled="isView"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row mb-3">
            <div class="col-sm-3" style="min-width: 120px">
                <label class="text-nowrap"
                    >{{ $t('managerForm.settingSerialCode.campaignPeriod') }}
                    <span v-if="onHandleCheckFieldRequired(configValid.start_date.typesValidate)" class="text-danger">*</span></label
                >
                <p class="mb-0 text-nowrap">{{ $t('managerForm.settingSerialCode.(lotteryPeriod)') }}</p>
            </div>
            <div class="col-sm-9">
                <div class="d-flex flex-wrap" style="gap: 0.5rem">
                    <DateNormal
                        :full_date.sync="formLottery.start_date"
                        :config.sync="configValid.start_date"
                        :disabled="isView"
                        @blur="onHandleValid(formLottery.start_date, configValid.start_date, 'date')"
                    >
                        <div v-if="configValid.start_date.error" class="invalid-feedback d-block">
                            <span>{{ configValid.start_date.errorText }}</span>
                        </div>
                    </DateNormal>
                    <div class="mt-2 h-100">〜</div>
                    <DateNormal
                        :full_date.sync="formLottery.end_date"
                        :config.sync="configValid.end_date"
                        :disabled="isView"
                        @blur="onHandleValid(formLottery.end_date, configValid.end_date, 'date')"
                    ></DateNormal>
                </div>
                <div v-if="configValid.end_date.error" class="invalid-feedback d-block">
                    <span>{{ configValid.end_date.errorField }}</span>
                </div>
            </div>
        </div>
        <div class="form-group row mb-3">
            <label class="col-sm-3 text-nowrap" style="min-width: 120px"
                >{{ $t('managerForm.settingSerialCode.winningTimeSetting') }}
                <span v-if="onHandleCheckFieldRequired(configValid.start_time_winning.typesValidate)" class="text-danger">*</span>
            </label>
            <div class="col-sm-9">
                <div class="d-flex" style="gap: 0.5rem">
                    <PickerDate
                        :id="`startTimeLottery`"
                        class="col-sm-1 p-0"
                        style="min-width: 90px"
                        :model.sync="formLottery.start_time_winning"
                        :config.sync="configValid.start_time_winning"
                        :disabled="isView"
                        @change="onHandleValid(formLottery.start_time_winning, configValid.start_time_winning, 'time')"
                        @close="onHandleClose"
                    />
                    <div class="mt-2">〜</div>
                    <div>
                        <PickerDate
                            :id="`endTimeLottery`"
                            class="col-sm-1 p-0"
                            style="min-width: 90px"
                            :model.sync="formLottery.end_time_winning"
                            :config.sync="configValid.end_time_winning"
                            :disabled="isView"
                            @change="onHandleValid(formLottery.end_time_winning, configValid.end_time_winning, 'time')"
                            @close="onHandleClose"
                        />
                        <div v-if="configValid.end_time_winning.error" class="invalid-feedback d-block">
                            <span>{{ configValid.end_time_winning.errorField }}</span>
                        </div>
                    </div>
                    <div></div>
                </div>
                <div v-if="configValid.start_time_winning.error" class="invalid-feedback d-block">
                    <span>{{ configValid.start_time_winning.errorField }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import PickerDate from '@/components/DateCustoms/PickerDate/main.vue';

import { InputCheckBox, InputRadio } from '@/components/Input';
import { OPTIONS_SERIAL_CODE_USED, onValidDate, onValidTime } from '@/views/pages/phase2/manager-form/components/setting-lottery/constants';
import { onHandleCheckFieldRequired } from '@/utils/handlers';
import { validateField } from '@/utils/validate_v2';
export default {
    name: 'SettingSerialCodeLottery',
    components: {
        InputCheckBox,
        InputRadio,
        DateNormal,
        PickerDate
    },
    props: {
        dataForm: {
            type: Object,
            default: () => {}
        },
        dataSerialCode: {
            type: Object,
            default: () => {}
        },
        configValid: {
            type: Object,
            default: () => {}
        },
        dataPrizes: {
            type: Array,
            default: () => []
        },
        isView: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            serialCodeList: OPTIONS_SERIAL_CODE_USED(),
            formLottery: this.dataForm,
            listPrizes: this.dataPrizes
        };
    },
    methods: {
        onHandleCheckFieldRequired,

        onHandleValid(valueField, configField, typeField = null) {
            validateField(valueField, configField);
            if (typeField === 'date') {
                onValidDate(this.formLottery, this.configValid);
            } else if (typeField === 'time') {
                onValidTime(this.formLottery, this.configValid);
            }
        },

        onHandleClose() {
            if (!!this.formLottery.start_time_winning && !!this.formLottery.end_time_winning) {
                this.listPrizes = this.listPrizes.map((item) => {
                    return {
                        ...item,
                        start_time_winning: item.start_time_winning || this.formLottery.start_time_winning,
                        end_time_winning: item.end_time_winning || this.formLottery.end_time_winning
                    };
                });
                this.$emit('update:dataPrizes', this.listPrizes);
            }
        }
    },
    watch: {
        formLottery: {
            handler(val) {
                this.$emit('update:dataForm', val);
            },
            immediate: true,
            deep: true
        },

        dataPrizes: {
            handler(val) {
                this.listPrizes = val;
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
